import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { BlankLayoutComponent } from './layout/blank-layout/blank-layout.component';
import { ErrorComponent } from './pages/error/error.component';
import { NotAuthComponent } from './pages/not-auth/not-auth.component';
import { UserPreferencesComponent } from './features/administration/user-management/user-preferences/user-preferences.component';
import { UserProfileComponent } from './features/administration/user-management/user-profile/user-profile.component';
import { GatePassPrintComponent } from './features/gate-management/gate-pass/gate-pass-print/gate-pass-print.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/admin/dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
      },
      { path: 'gate-pass/print/:Doc_ID/:VisitType', component: GatePassPrintComponent }
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'myprofile', component: UserProfileComponent },
      { path: 'user-preferences', component: UserPreferencesComponent },
      { path: 'notAuthorized', component: NotAuthComponent },
      {
        path: 'dashboard',
        title: 'header.dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
      },

      {
        path: 'MyInbox',
        title: 'header.my_inbox',
        loadChildren: () => import('./features/my-inbox/my-inbox-routing.module').then(m => m.MyInboxRoutingModule)
      },

      {
        path: 'inbound',
        title: 'header.inbound',
        loadChildren: () => import('./features/inbound/inbound.module').then(m => m.InboundModule)
      },
      {
        path: 'task-management',
        title: 'header.task_management',
        loadChildren: () => import('./features/task-management/task-management.module').then(m => m.TaskManagementModule)
      },
      {
        path: 'task',
        title: 'task.task',
        loadChildren: () => import('./features/task/task.module').then(m => m.TaskModule)
      },
      {
        path: 'outbound',
        title: 'header.outbound',
        loadChildren: () => import('./features/outbound/outbound.module').then(m => m.OutboundModule)
      },
      {
        path: 'distribution-management',
        title: 'header.distribution_management',
        loadChildren: () => import('./features/distribution-management/distribution-management.module').then(m => m.DistributionManagementModule)
      },
      {
        path: 'inventory',
        title: 'header.inventory',
        loadChildren: () => import('./features/inventory/inventory.module').then(m => m.InventoryModule)
      },
      {
        path: 'human-capital',
        title: 'header.human_capital',
        loadChildren: () => import('./features/human-capital/human-capital.module').then(m => m.HumanCapitalModule)
      },
      {
        path: 'facility-setup',
        title: 'header.facility_setup',
        loadChildren: () => import('./features/facility-setup/facility-setup.module').then(m => m.FacilitySetupModule)
      },
      {
        path: 'inventory-setup',
        title: 'header.inventory_setup',
        loadChildren: () => import('./features/inventory-setup/inventory-setup.module').then(m => m.InventorySetupModule)
      },
      {
        path: 'administration',
        title: 'header.administration',
        loadChildren: () => import('./features/administration/administration.module').then(m => m.AdministrationModule)
      },
     
      {
        path: 'settings-setup',
        title: 'header.setup_settings',
        loadChildren: () => import('./features/settings-setup/settings-setup.module').then(m => m.SettingsSetupModule)
      },
      {
        path: 'business-insights',
        title: 'header.business_insights',
        loadChildren: () => import('./features/business-insights/business-insights.module').then(m => m.BusinessInsightsModule)
      },
      {
        path: 'gate-management',
        title: 'header.gate_management',
        loadChildren: () => import('./features/gate-management/gate-management.module').then(m => m.GateManagementModule)
      },

      {
        path:'workflowSetting',
        title:'header.workflow_settings',
        loadChildren: () => import('./features/work-flow-setting/work-flow-setting.module').then(m => m.WorkFlowSettingModule)

      },
      {
        path:'incidentManagment',
        title:'header.incident_managment',
        loadChildren: () => import('./features/incident-management/incident-management.module').then(m => m.IncidentManagementModule)

      },
      {
        path:'incidentType',
        title:'Incident Type',
        loadChildren: () => import('./features/incident-management/incident-type/incident-type.module').then(m => m.IncidentTypeModule)

      },
      
      { path: '**', component: ErrorComponent }
    ]
  },
  {
    path: 'my-reports',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        title: 'header.reports',
        loadChildren: () => import('./features/my-reports/my-reports.module').then(m => m.MyReportsModule)
      }
    ]
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        title: 'header.reports',
        loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule)
      }
    ]
  },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 64]
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
